export enum KeyCode {
  ArrowDown = 40,
  ArrowUp = 38,
  Escape = 27,
  Enter = 13,
  Tab = 9,
}
